import { localDevelopment } from '../model/StaticVariables';
import VectorSource from 'ol/source/Vector';
import { DevDataService } from '../model/DevDataService';
import TopoJSON from 'ol/format/TopoJSON';
import GeoJSON from 'ol/format/GeoJSON';
import * as mapStyles from '../view/MapVectorStyles.js';
import { OneMapApiDataService } from '../model/OneMapApiDataService';
import { countiesList, dataProjection, featureProjection, statesList, minCensusZoom } from '../model/StaticVariables';

const DS = new DevDataService();
const ODS = new OneMapApiDataService();

const getCountyLayerReference = (map) => {
    return map.getLayers().array_.find(function (lyr) {
        return lyr.get('title') === 'referenceCounty';
    });
};

const convertGeometryToFeatures = (data, format = 'topojson') => {
    //ΔVΔVΔ: note for later conver to TopoJson or geojson based on data
    const clonedData = Object.assign({}, data);
    var features;
    if (format === 'topojson') {
        let firstNode = Object.keys(clonedData.objects)[0];
        features = new TopoJSON({
            layers: firstNode
        }).readFeatures(clonedData, {
            dataProjection,
            featureProjection
        });
    }
    if (format === 'geojson') {
        features = new GeoJSON({
            // layers: firstNode,
        }).readFeatures(clonedData, {
            dataProjection,
            featureProjection
        });
    }
    return features;
};
const getTileExtent = (map, lyr) => {
    const extent = map.getView().calculateExtent(map.getSize());
    const grid = lyr.getSource().tileGrid;
    // const tiles = [];
    const tilesObj = {};
    grid.forEachTileCoord(extent, map.getView().getZoom(), (coord) => {
        let tileExtent = grid.getTileCoordExtent(coord);
        tilesObj[`z:${coord[0]}x:${coord[1]}y:${coord[2]}`] = tileExtent;
        // tiles.push(tileExtent);
    });
    // return tiles;
    return tilesObj;
};
export { getTileExtent };

const getFipsFromExtent = (map, id) => {
    const obj = {
        features: [],
        stateNames: [],
        stateFips: [],
        countyFips: [],
        featureFips: []
    };
    if (!map) return obj;
    const mapExtent = map.getView().calculateExtent();
    const countyLyr = getCountyLayerReference(map);
    if (!countyLyr) return obj;
    const countyLyrSource = countyLyr.getSource();
    //ΔVΔVΔ: Use if lyr is visible
    // countyLyrSource.forEachFeature((feature)=>{
    //     feature.setStyle( mapStyles.outOfScope)
    // })
    countyLyrSource.forEachFeatureIntersectingExtent(mapExtent, function (feature) {
        let fips = feature.get('FIPS') || feature.get('STATEFP') + feature.get('COUNTYFP');
        fips = fips.toString();
        let stateName =
            feature.get('STATE_NAME') ||
            statesList.find((st) => {
                return st.id === feature.get('STATEFP');
            })?.label;
        //    feature.setStyle( mapStyles.flatColorCountyStyle('#fff8dcab')) //cornsilk

        obj.features.push(feature);
        obj.featureFips[fips] = true;
        obj.stateNames[stateName] = true;
        obj.countyFips[fips.substr(0, 5)] = true;
        obj.stateFips[fips.substr(0, 2)] = true;
    });
    obj.countyFips = Object.keys(obj.countyFips);
    obj.stateFips = Object.keys(obj.stateFips);
    obj.stateNames = Object.keys(obj.stateNames);
    return obj;
};

const getFeatureFipsFromExtent = (map, detail = 'low') => {
    const obj = new Set();
    if (!map) return obj;
    const mapExtent = map.getView().calculateExtent();
    const countyLyr = getCountyLayerReference(map);
    if (!countyLyr) return obj;
    const countyLyrSource = countyLyr.getSource();

    countyLyrSource.forEachFeatureIntersectingExtent(mapExtent, function (feature) {
        let fips = feature.get('FIPS') || feature.get('STATEFP') + feature.get('COUNTYFP');
        fips = detail === 'low' ? fips.toString().substring(0, 2) : fips.toString();
        obj.add(fips);
    });
    return obj;
};
export { getFeatureFipsFromExtent };

const getPoiData = async (props) => {
    const { scope, tilesObj } = props;
    var promises;

    // tileObj = {
    //     "z:4x:3y:5": [ -12523442.714243278, 5009377.085697312, -10018754.171394622, 7514065.628545968 ],
    //      "z:4x:3y:6": [ -12523442.714243278, 2504688.542848654, -10018754.171394622, 5009377.08569731 ]
    // }
    //ΔVΔVΔ: Get mock data for local dev
    if (localDevelopment) {
        let key = Object.keys(tilesObj)[0];
        let zoom = key.split(':')[1].replace(/x/, '');
        const url = `/data//poijson/poi_zoom_${zoom}_${scope}.json`;
        const json = fetch(url)
            .then((data) => data.json())
            .then((res) => {
                const tilekeys = Object.keys(tilesObj);
                return tilekeys.map((key, i) => {
                    let tile = res[i];
                    if (!tile) return { extent: tilesObj[key], count: 0, data: [] };

                    console.log(key, i, tile, tile.Table1[0]);
                    return { extent: tilesObj[key], count: tile.Table1[0].Count, data: tile.Table };
                });
            });
        promises = [json];
        console.log(await json);
        return Promise.all(promises);
    }

    //ΔVΔVΔ: Get Live Data, loop through map tiles in extent
    promises = Object.keys(tilesObj).map(async (key) => {
        let t = tilesObj[key];
        const tileExtent = { x1: t[0], y1: t[1], x2: t[2], y2: t[3] };
        return DS.getPOIData({ scope, extent: tileExtent, extentKey: key }).then((data) => {
            data.tileExtent = tileExtent;
            data.key = key;
            return data;
        });
    });
    return Promise.all(promises);
};
export { getPoiData };

const addCountyFIPSInfo = async (features) => {
    return features.map(function (feat) {
        let cdc = feat.get('ID');
        let countyFIPS = countiesList.find(function (d) {
            return d.CDC === cdc;
        });
        try {
            feat.set('FIPS', countyFIPS.CC);
            feat.set('COUNTY', countyFIPS.CN);
            feat.set('STATE_NAME', countyFIPS.SN);
        } catch (err) {
            console.error('Err:213, could not assign County FIPS');
        }
        return feat;
    });
};

const countiesFromFips = (geometry) => {
    var expandedCountyExtent = {};
    geometry.forEach((geo) => {
        let fips = geo.get('FIPS');
        let cntyfips = fips.substr(0, 5);
        expandedCountyExtent[cntyfips] = true;
    });
    return Object.keys(expandedCountyExtent);
};

const getVisibleGeometry = async (props) => {
    const { scope, tract, fipsList, year, zoom } = props;
    var features = [];
    if (zoom < minCensusZoom) {
        features = await getSimpleGeometry({ tract, year });
    } else {
        features = await getDetailedGeometry({ scope, tract, fipsList, year }).catch((err) => {
            throw err;
        });
    }
    if (features.length && features[0]?.get('STATEFP')) {
        features = features.map((f) => {
            let fips = f.get('FIPS') || f.get('GEOID') || f.get('STATEFP') + f.get('COUNTYFP');
            f.set('FIPS', fips);
            f.set('ID', fips);
            f.set('COUNTY', f.get('NAME'));
            let fstate = statesList.find((st) => {
                return st.id + '' === f.get('STATEFP');
            });
            if (fstate) {
                f.set('STATE_NAME', fstate.abbr);
            }
            return f;
        });
    } else if (features.length && !features[0].get('FIPS')) {
        features = await addCountyFIPSInfo(features, countiesList);
    }
    return features;
};
const memoSimpleGeo = {};
const getSimpleGeometry = async (props) => {
    const { tract, year } = props;
    if (tract === 'county') {
        if (year in memoSimpleGeo) return memoSimpleGeo[year];
        const geo = await DS.getGeometryData({ scope: 'national', tract: 'county', year }).then((rez) => convertGeometryToFeatures(rez[0]));
        memoSimpleGeo[year] = geo;
        return geo;
    } else {
        // ΔVΔVΔ: dont lookup census, too far zoomed in
        return [];
    }
};
export { getSimpleGeometry };
//

const getDetailedGeometry = async (props) => {
    const { scope, tract, fipsList, year } = props;
    var combinedFeatures = [];
    const FFips = fipsList?.length || fipsList?.size ? fipsList : [0, 1, 2, 3, 4, 5, 6, 7]; //Fallback if Fips is empty get all results
    const promises = [];
    for (let fips of FFips) {
        let p = ODS.getGeometryData({ scope, tract, year, fips: [fips] }).then((res) => {
            res.forEach((rez) => {
                const resultFeatures = convertGeometryToFeatures(rez, 'geojson');
                combinedFeatures = combinedFeatures.concat(resultFeatures);
            });
        });
        promises.push(p);
    }

    await Promise.all(promises);
    return combinedFeatures;
};

const getVisibleSVI = async (props) => {
    const { theme, year, scope, tract, state, fips } = props;
    return ODS.getSVIData({ theme, year, scope, state, tract, fips });
};
const withinScope = (scope, state, fips) => {
    //this would make everything true always, needs check if compare is stare
    if (scope === 'national') return true;
    if (!state) return false; //state scope but no state selected
    return state.id + '' == fips.substr(0, 2);
};
const getSviStyle = (data, theme, county = false, zoom = 5) => {
    if (!data) return null;
    const themeColorSet = theme.colorScheme;
    const low = zoom < 6;
    const themeSlug = 'theme' + theme.id;
    const sviThemeValue = data[themeSlug] + (low ? '_low' : '') + (county ? '_county' : '');
    return themeColorSet[sviThemeValue] || mapStyles.noData;
};
const stylizeGeometry = (features, scope, theme, state, sviData, county = false, useStyle = false, zoom = 5) => {
    features.forEach((shape) => {
        const fips = shape.get('FIPS') || shape.get('STATEFP') + shape.get('COUNTYFP');
        let sviValues = sviData[fips] ? sviData[fips] : { theme0: false, theme1: false, theme2: false, theme3: false, theme4: false, theme0Num: 0, theme1Num: 0, theme2Num: 0, them30Num: 0, theme4Num: 0 };
        shape.set('sviValues', sviValues);
        shape.set('hover', false);
        //need scope
        let inScope = withinScope(scope, state, fips);

        let sviStyle = useStyle ? useStyle : getSviStyle(sviData[fips], theme, county, zoom) || mapStyles.noData;
        if (!inScope) {
            sviStyle = mapStyles.outOfScope;
        }

        if (typeof sviStyle == 'object') shape.setStyle(sviStyle);
    });
    return features;
};

export { addCountyFIPSInfo, getCountyLayerReference, convertGeometryToFeatures, getFipsFromExtent, getVisibleGeometry, getVisibleSVI, stylizeGeometry, countiesFromFips };
